import React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab } from "react-bootstrap";
import ReactTable from "react-table";
import moment from "moment";
import SpecialAvailability from "components/menu/master-files/workers-maintenance/worker-profile-components/special-availability";
import Vacation from "components/menu/master-files/workers-maintenance/worker-profile-components/vacation";

class TabWorkerAvailability extends React.Component {
    tabs = [];

    tabsKeys = [];

    constructor(props) {
        super(props);

        this.tabsKeys = {
            GeneralAvailability: "GeneralAvailability",
            SpecialAvailability: "SpecialAvailability",
            Vacation: "Vacation"
        };

        this.state = {
            tabKey: this.tabsKeys.GeneralAvailability
        };
    }

    changeTab = tabKey => {
        this.setState({
            tabKey
        });
    };

    render () {
        const generalAvailability = this.props.getEmployeeValue("generalAvailability", this.props.tabKey) || false;
        const specialAvailability = this.props.getEmployeeValue("specialAvailabilities", this.props.tabKey) || false;
        const vacations = this.props.getEmployeeValue("vacations", this.props.tabKey) || [];

        let dailyAvailabilities = false;
        if (generalAvailability && generalAvailability.dailyAvailabilities !== null && typeof generalAvailability.dailyAvailabilities === "object") {
            dailyAvailabilities = Object.keys(generalAvailability.dailyAvailabilities)
                .map((key) => generalAvailability.dailyAvailabilities[key]);
        }

        return (
            <div className="mt-3">
                <Tabs
                    id="controlled-tab-example"
                    activeKey={this.state.tabKey}
                    onSelect={this.changeTab}
                >
                    <Tab
                        eventKey={this.tabsKeys.GeneralAvailability}
                        title="General Availability"
                    >
                        <div className="row mt-3">
                            <div className="col-8">
                                {dailyAvailabilities ?
                                    <ReactTable
                                        data={dailyAvailabilities}
                                        headerClassName="table-header"
                                        columns={[{
                                            Header: "#",
                                            headerClassName: "text-left",
                                            Cell: ({ original, index }) =>
                                                moment.weekdays(true, index-1) ,
                                        }, {
                                            Header: "Start",
                                            headerClassName: "text-left",
                                            Cell: ({ original }) => original.start,
                                        }, {
                                            Header: "End",
                                            headerClassName: "text-left",
                                            Cell: ({ original }) => original.end,
                                        },  {
                                            Header: "Desired Hours",
                                            Cell: ({ original }) => original.desiredHours,
                                        }, {
                                            Header: "Daily Hours",
                                            headerClassName: "text-left",
                                            Cell: ({ original }) => original.availableHours,
                                        }]}
                                        defaultPageSize={dailyAvailabilities.length}
                                        className="-striped -highlight"
                                        showPagination={false}
                                        NoDataComponent={() => null}
                                    />
                                :
                                    <div className="text-danger h-100 d-flex justify-content-center align-items-center">
                                        Daily Availability Not Set
                                    </div>
                                }
                            </div>
                            <div className="col-3 text-right">
                                <div className="mt-2">
                                    Weekly Minimum Hours:
                                    <b> {generalAvailability.weeklyHoursMinimum}</b>
                                </div>
                                <div className="mt-2">
                                    Weekly Maximum Hours:
                                    <b> {generalAvailability.weeklyHoursMaximum}</b>
                                </div>
                                <div className="mt-2">
                                    Weekly Preferred Hours:
                                    <b> {generalAvailability.weeklyHoursPreferred}</b>
                                </div>
                            </div>
                        </div>
                    </Tab>

                    <Tab
                        eventKey={this.tabsKeys.SpecialAvailability}
                        title="Special Availability"
                    >
                        <SpecialAvailability
                            specialAvailability={specialAvailability}
                        />
                    </Tab>

                    <Tab
                        eventKey={this.tabsKeys.Vacation}
                        title="Vacation"
                    >
                        <Vacation
                            vacations={vacations}
                        />
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

TabWorkerAvailability.propTpes = {
    workerId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    tabKey: PropTypes.string.isRequired,
    getEmployeeValue: PropTypes.func.isRequired
};

export default TabWorkerAvailability;
